import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Blueprint } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { BlueprintSuggestions } from "shared/Blueprint/constants";

import BlueprintStateBadge from "../../StateBadge";
import useCellFilterAction from "../useCellFilterAction";

const BlueprintsTableStatusCell = ({
  item: blueprint,
  ...cellProps
}: TableSimpleCellProps<Blueprint>) => {
  const filterAction = useCellFilterAction({
    filterName: BlueprintSuggestions.State,
    filterValue: blueprint.state,
  });
  const actions = useMemo(() => [filterAction], [filterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <BlueprintStateBadge state={blueprint.state} />
    </TableSimpleCell>
  );
};

export default BlueprintsTableStatusCell;
